import type { ApiModuleEndpoints } from '../types'

export const saleReturnApiEndpoints = {
  saleReturns: { method: 'GET', path: '/sale-returns', requiresAuth: true },
  createSaleReturn: { method: 'POST', path: '/sale-returns', requiresAuth: true },
  saleReturnDetail: { method: 'GET', path: '/sale-returns/:id', requiresAuth: true },
  updateSaleReturn: { method: 'PUT', path: '/sale-returns/:id', requiresAuth: true },
  deleteSaleReturn: { method: 'DELETE', path: '/sale-returns/:id', requiresAuth: true },
  completeSaleReturn: { method: 'POST', path: '/sale-returns/:id/complete', requiresAuth: true },
  rejectSaleReturn: { method: 'POST', path: '/sale-returns/:id/reject', requiresAuth: true },
  cancelSaleReturn: { method: 'POST', path: '/sale-returns/:id/cancel', requiresAuth: true },
  returnableInvoices: { method: 'GET', path: '/sale-returns/sales-invoices', requiresAuth: true },
  returnableInvoiceItems: {
    method: 'GET',
    path: '/sale-returns/sales-invoices/:id/returnable-items',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
